import Contact from "pages/Contact";

export default function ContactPage() {
    return <Contact />;
}
